import api from '@pray/shared/utils/api';

export async function testIntegration({ artistId, type, integrationDetails, leadClientId = null, scope = null }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!type) throw Error('Type is required');
  if (!integrationDetails) throw Error('Integration details is required');

  const data = {
    type,
    integration_details: integrationDetails,
  };

  // Lets the server test with the stored credential instead of the browser sending one.
  if (leadClientId) data.lead_client_id = leadClientId;

  // Only read when there is no saved client. A saved row's own scope wins server-side, since
  // scope is fixed at creation and the PUT schema refuses it.
  if (scope) data.scope = scope;

  const url = `/web/studio/artists/${artistId}/lead-client-test`;
  const response = await api.executePostRequest(url, data);

  return response.data;
}
